// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MarketPage_wrapper_1Nn_L"};